<template>
    <div>
        <h5 class="info-text"></h5>
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="row justify-content-center">
                    <div v-show="campagnePreviewHtml" v-html="campagneShortener" class="col-12"></div>
                </div>

                <div v-show="!campagnePreviewHtml" class="row justify-content-center"
                     style="height: 350px; overflow: hidden">
                    <div style="width: 100%; height: 100%; display: table">
                        <span style="vertical-align: middle;display: table-cell; text-align: center">
                          <font-awesome-icon icon="fa-solid fa-rotate" class="fa-spin"
                                             style="font-size: 50px; color: lightskyblue"/>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {IconCheckbox} from 'src/components/UIComponents'
    import axios from 'axios';

    const urlshortener = process.env.VUE_APP_URL_SHORTENER_URL;

    export default {
        components: {
            IconCheckbox
        },
        props: {
            campagneMailchimp: {
                type: [Object, Array],
                description: 'Campagne mailchimp'
            }
        },
        watch: {
            campagneMailchimp: function (newVal, oldVal) {
                this.campagnePreviewHtml = false;
                if (newVal != '') {
                    axios.post(`${urlshortener}/mailchimp/campagnes/shortener/${newVal.langue}/` + newVal.id, {
                        html: newVal.html,
                        headers: {
                            'Accept': 'application/vnd.api+json',
                            'Content-Type': 'application/vnd.api+json',
                        }
                    }).then(response => {
                        this.campagneShortener = response.data;
                        this.campagnePreviewHtml = true;
                        this.campagneMailchimp.html = this.campagneShortener;
                        // this.model.campagneMailchimp = this.campagneMailchimp;

                    });
                }
            }
        },
        data() {
            return {
                model: {
                    design: true,
                    code: false,
                    develop: false
                },
                campagneShortener: '',
                campagnePreviewHtml: false
            }
        },
        methods: {
            validate() {
                this.$emit("update-campagne-mailchimp", {
                    id: this.campagneMailchimp.id,
                    html: this.campagneShortener,
                    langue: this.campagneMailchimp.langue,
                    validate: true
                });
                return Promise.resolve(true)
            }
        }
    }
</script>
<style>
</style>
